<script setup lang="ts">
import { ProcessingAnimation } from '@forgd/ui-kit/blocks/animations'
</script>

<template>
  <div class="my-auto flex flex-col items-center gap-5 text-center">
    <ProcessingAnimation />
    <div class="flex flex-col gap-1">
      <p class="text-xl leading-tight font-semibold text-primal">
        We are processing your submission...
      </p>
      <p class="text-sm text-gray-600">
        Do not close this window
      </p>
    </div>
  </div>
</template>
